"use client";

import type { Locale } from "@/config/i18n";
import { EXCURSION_UI } from "./excursionUi";
import { tr } from "@/config/localeText";

type Props = {
  title: string;
  items: { icon?: string; text: string }[];
  locale?: Locale;
};

const HighlightsSection = ({
  title,
  items,
  locale = "fr",
}: Props): JSX.Element => {
  const ui = tr(EXCURSION_UI, locale);
  return (
    <section className="relative bg-white py-16 text-black">
      <div className="relative mx-auto max-w-[90rem] px-6 md:px-8">
        <h2 className="mb-2 font-space-age text-lg tracking-[0.2em]">
          {title}
        </h2>
        <p className="mb-8 max-w-3xl text-sm text-black/70">
          {ui.highlightsIntro}
        </p>
        <ul className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((it, idx) => (
            <li
              key={idx}
              className="group relative overflow-hidden rounded-2xl border border-black/10 bg-black/[0.02] p-6 transition-transform duration-300 hover:-translate-y-0.5 hover:bg-black/[0.04]"
            >
              <div
                className="absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
                style={{
                  background:
                    "radial-gradient(600px circle at var(--x,50%) var(--y,50%), rgba(0,0,0,0.08), transparent 40%)",
                }}
              />
              <div className="relative flex items-start gap-3">
                {it.icon && (
                  <span className="mt-1 inline-flex h-6 w-6 items-center justify-center rounded-full bg-black/10 text-black/80">
                    {it.icon}
                  </span>
                )}
                <p className="text-sm text-black/85">{it.text}</p>
              </div>
            </li>
          ))}
        </ul>
        <p className="sr-only">
          {ui.highlightsSrPrefix}
          {items.map((i) => i.text).join(", ")}
        </p>
      </div>
    </section>
  );
};

export default HighlightsSection;
